<template>
  <div>
    <div v-wechat-title='"最無厘頭放置手遊《最強蝸牛》"'></div>
    <div class="special-page">
      <div class="small-title"></div>

      <div class="area">
        <div class="big-title"></div>
        <div class="fb-btn" @click="goDownload"></div>

        <div class="pay_box">
          <div class="pay_item" @click="goToLink('fb')"></div>
          <div class="pay_item" @click="goToLink('youtube')"></div>
          <div class="pay_item" @click="goToLink('discord')"></div>
        </div>
      </div>

      <div class="video-btn" :class="{ playing: isPlaying }" @click="toggleMusic"></div>
      <audio ref="bgMusic" loop>
        <source src="../../snail_5thLeading/index/snail.mp3" type="audio/mpeg" />
      </audio>

      <div class="tv_box">
        <div class="tv">
          <div class="play btnT" @click="showMedia"></div>
        </div>

        <!-- 视频弹窗容器 -->
      </div>

      <div class="video_wrap new_popup_wrap" :class="{ active: mediaShow }">
        <div class="video_box_pop popup_box">
          <div class="popup_content">
            <iframe ref="mediaIframe" width="1621" height="841" :src="videoSrc"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen title="YouTube video" frameborder="0"
              referrerpolicy="strict-origin-when-cross-origin"></iframe>
          </div>

          <!-- 关闭按钮 -->
          <div class="close_wrapper btn" @click="hideMedia"></div>
        </div>
      </div>
    </div>


    <div class="content-footer">
      <div class="footer-content zh_HK">
        <div class="footer-box">
          <div class="left-content">
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/service_agreement.html">服務條款</a>
            <span class="line"></span>
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/privacy_policy.html">隱私協議</a>
          </div>
          <div class="l-logo" style="margin-right: 10px">
            <img src='https://download4.qcplay.com/qcgame-api/gPoRObLEHj6gH4Nttorxvu9j4z5bXnJ13ASABCat.png'>
          </div>

          <div class="right-content">
            <div class="r-text">
              <p>*思耐爾數位為最強蝸牛在台港澳的授權代理商。</p>
              <p>*本遊戲因涉及暴力、不當言語之情節，依遊戲軟體分級管理辦法分類為輔12級。</p>
              <p>*注意使用時間，避免沉迷於遊戲。</p>
              <p>*本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力適度消費。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
export default {
  components: {},
  data() {
    return {
      gLink: [
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=1',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=2',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=3',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=4',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=5',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=6',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=7',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=8',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=9',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=10'
      ],
      videoSrc: '',
      mediaShow: false,
      isPlaying: false
    };
  },
  created() {
    // 埋点

  },
  beforeDestroy() {
    document.documentElement.classList.remove('special-page-active');
    document.body.classList.remove('special-page-active');
  },
  mounted() {
    this.autoRedirectToEnter();

    this.$nextTick(() => {
      document.documentElement.classList.add('special-page-active');
      document.body.classList.add('special-page-active');
      this.playMusic()

      // 埋点
      const bl = buriedLogger("snail", "蜗牛_港澳台五周年_专题页h5");
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum("蜗牛_港澳台五周年_专题页统计");

        // 自定义统计日志
        this.logger.sum("蜗牛_港澳台五周年_专题页首页访问");
      }, 200);
    });
  },
  computed: {},
  methods: {
    handleLink() {
      const ua = navigator.userAgent.toLowerCase();
      const new_isIOS = /iphone|ipad|ipod/.test(ua);

      const defaultIOS = 'https://play.google.com/store/apps/details?id=com.ltgames.android.snail';
      const defaultAndroid = 'https://play.google.com/store/apps/details?id=com.ltgames.android.snail';

      const path = window.location.pathname;
      const parts = path.split('/');
      const channelPart = parts.find(p => /^\d{1,2}$/.test(p)); // 找第一个纯数字（1-2位）

      const index = channelPart ? parseInt(channelPart, 10) : null;

      let url = '';

      if (index >= 1 && index <= 10) {
        url = this.gLink[index - 1]
      } else {
        url = new_isIOS ? defaultIOS : defaultAndroid;
      }

      if (url) {
        window.open(url, '_blank');
      }

      window.open(url, '_blank');
    },
    goToLink(platform) {
      const links = {
        fb: 'https://www.facebook.com/TheMarvelousSnail/',
        youtube: 'https://www.youtube.com/channel/UCuQlUk5enYeww2ZntXMacJA',
        discord: 'https://discord.gg/CqjPFG5qHa'
      };
      // 在当前窗口打开，不会新开标签页（适用于移动端）
      window.open(links[platform], '_blank');
    },
    goDownload() {
      const isIOS = /iPhone|iPod|iOS/i.test(navigator.userAgent);
      const platform = isIOS ? 'ios' : 'and';
      const contentId = isIOS ? 'iosshop' : 'andshop';
      // 平台特定事件
      window.fbq('track', `click_${contentId}`);
      window.gtag('event', `${platform}立即下载`);

      // 埋点
      window.qcq("track", "click", { "store": "android" });
      window.qcq("track", "click", { "store": "ios" });


      const { utm_source, utm_medium, utm_campaign, utm_content } = analysisParams(window.location.href);
      window.qcq("track", "book", {
        game_id: 120,
        utm_source: utm_source || '',
        utm_medium: utm_medium || '',
        utm_campaign: utm_campaign || '',
        utm_content: utm_content || '',
        os: !navigator.userAgent.match(/(iPhone|iPod|ios)/i) ? 'Android' : 'IOS',
      })

      this.handleLink()
    },
    autoRedirectToEnter() {
      const { protocol, host, pathname, search } = window.location;
      const isMobile = /iphone|ipad|ipod|android/i.test(navigator.userAgent);

      // ✅ 非移动端不处理
      if (!isMobile) return;

      // ✅ 如果已经在 /enterxxxx/ 页面，就不要跳了（避免死循环）
      const isInEnterPage = /^\/snail_5thSpecial\/enter\d{4,}/.test(pathname);
      if (isInEnterPage) return;

      // ✅ 提取路径中第一个纯数字（支持任意位数）
      const pathParts = pathname.split('/');
      const xParam = pathParts.find(p => /^\d+$/.test(p));

      // ✅ 构造跳转路径
      const timestamp = Date.now();
      const newPath = `/snail_5thSpecial/enter${timestamp}${xParam ? `/${xParam}/` : '/'}`;
      const redirectUrl = `${protocol}//${host}${newPath}${search}`;

      // ✅ 跳转（不留历史记录）
      window.location.replace(redirectUrl);
    },

    playMusic() {
      const music = this.$refs.bgMusic;
      // 尝试播放音频
      music.play().then(() => {
        this.isPlaying = true;
      }).catch(() => {
        // 可能被浏览器拦截，处理权限请求或提示
        this.isPlaying = false;
      });
    },
    toggleMusic() {
      const music = this.$refs.bgMusic;
      if (this.isPlaying) {
        music.pause();
        this.isPlaying = false;
      } else {
        music.play();
        this.isPlaying = true;
      }
    },
    showMedia() {
      this.videoSrc = "https://www.youtube.com/embed/25S-bUjd910";
      this.mediaShow = true;
    },
    hideMedia() {
      this.mediaShow = false;
      this.videoSrc = ""; // 清除视频以停止播放
    },
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/snail_5thSpecial/pc/index.vue